import { render, staticRenderFns } from "./SealEditAreaComponent.vue?vue&type=template&id=3312a2d1&scoped=true&"
import script from "./SealEditAreaComponent.vue?vue&type=script&lang=js&"
export * from "./SealEditAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3312a2d1",
  null
  
)

export default component.exports